// ============================================================
// CHAT CONSTANTS
// Extracted from ChatConversation.js — pure data, no dependencies.
// ============================================================

export const QUESTION_TEMPLATES = {
  mood_for:     { text: 'What are you in the mood for?',        answers: ['Quick hi — see the vibe', 'Chat a bit first, then meet', 'Open to meeting if vibe matches', 'Just keeping it casual for now'] },
  social_level: { text: 'Pick your ideal conversation starter', answers: ['Hot take you strongly believe in', 'Something weird that happened to you recently', 'A controversial opinion', 'What you\'re obsessed with right now', 'A random life story'] },
  why_out:      { text: 'What brings you out today?',           answers: ['Up to meet people', 'Just chilling mostly', 'Celebrating something 🎉', 'Seeing where the night goes'] },
  where_now:    { text: 'If you had one superpower, which would it be?', answers: ['Read minds', 'Time travel', 'Teleport', 'Perfect memory', 'Talk to animals'] },
  color_wearing:{ text: 'What color can help me identify you?', answers: ['Mostly black / dark', 'Mostly white / light', 'Blue', 'Red / pink', 'Green', 'Yellow / bright tones', 'Mixed / hard to say'] }
};

export const QUICK_REPLIES = [
  '👍', '🙂', '😄', '😊', '😎', '👀',
  '😏', '🤔', '🔥', '😕', '😭', '🍻',
  '🙋‍♂️', '🙋‍♀️', '👋',
  'Same here', 'Sounds good', "That's interesting", 'Makes sense', 'Nice vibe', 'Are you there?'
];

export const IDENTITY_ACTIONS = [
  'wave my hand', 'raise my hand briefly', 'raise my drink for a few seconds',
  'hold the menu up and wave', 'hold up a coaster',
  'flash my phone torch briefly', 'raise a napkin/tissue'
];

// Game invite message text → gameType mapping
export const GAME_INVITES = {
  "Let's play Hangman?":        'hangman',
  "Let's play One Word Story?": 'story',
};
